
export default {
  data() {
    return {
      showPartener: false,
      partener: [
        {
          name: 'glh-footer.partener.stcn',
          url: 'http://www.stcn.com/',
        },

        {
          name: 'glh-footer.partener.sina',
          url: 'http://finance.sina.com.cn/stock/hkstock/',
        },
        {
          name: 'glh-footer.partener.163',
          url: 'http://money.163.com/hkstock/',
        },
        {
          name: 'glh-footer.partener.hexun',
          url: 'http://hk.stock.hexun.com/',
        },
        {
          name: 'glh-footer.partener.jrj',
          url: 'http://hk.jrj.com.cn/',
        },
        {
          name: 'glh-footer.partener.ftnn',
          url: 'http://www.futunn.com/',
        },
        {
          name: 'glh-footer.partener.cq',
          url: 'https://longbridgeapp.com/',
        },
        {
          name: 'glh-footer.partener.10jqka',
          url: 'http://www.10jqka.com.cn/',
        },
        {
          name: 'glh-footer.partener.eastmoney',
          url: 'http://www.eastmoney.com/',
        },
        {
          name: 'glh-footer.partener.xueqiu',
          url: 'https://xueqiu.com/',
        },
        {
          name: 'glh-footer.partener.stockstar',
          url: 'https://www.stockstar.com/',
        },
        {
          name: 'glh-footer.partener.cnfol',
          url: 'http://www.cnfol.com',
        },
        {
          name: 'glh-footer.partener.fx168',
          url: 'https://www.fx168.com/',
        },
        {
          name: 'glh-footer.partener.chinaventure',
          url: 'https://www.chinaventure.com.cn/',
        },
        {
          name: 'glh-footer.partener.moer',
          url: 'https://www.moer.cn/',
        },
        {
          name: 'glh-footer.partener.gildata',
          url: 'http://www.gildata.com/',
        },
        {
          name: 'glh-footer.partener.zqrb',
          url: 'http://www.zqrb.cn/',
        },
        {
          name: 'glh-footer.partener.cls',
          url: 'https://www.cls.cn/',
        },
        {
          name: 'glh-footer.partener.yzcj',
          url: 'http://www.123.com.cn/',
        },
        {
          name: 'glh-footer.partener.yly',
          url: 'https://www.youliancloud.cn/',
        },
        {
          name: 'glh-footer.partener.pcj',
          url: 'https://www.popcj.com/',
        },
        {
          name: 'glh-footer.partener.sdzx',
          url: 'https://www.time-weekly.com/',
        },
        {
          name: 'glh-footer.partener.leju',
          url: 'https://www.lejucaijing.com',
        },
        {
          name: 'glh-footer.partener.fuxin',
          url: 'https://www.fosunwealth.com/',
        },
        {
          name: 'glh-footer.partener.jfinfo',
          url: 'https://www.jfinfo.com/',
        },
        {
          name: 'glh-footer.partener.simupp',
          url: 'https://www.simuwang.com/',
        },
        {
          name: 'glh-footer.partener.hqlx',
          url: 'https://www.traveldaily.cn/',
        },
      ],
      about: [
        {
          text: 'glh-footer.navs.links.about',
          url: '/terms/introduction',
        },
        {
          text: 'glh-footer.navs.links.business',
          url: '/terms/contactUs',
        },

        {
          text: 'glh-footer.navs.links.hr',
          url: '/recruit',
        },
        {
          text: 'glh-footer.navs.links.contentCooperation',
          url: '/terms/contentCooperation',
        },
        {
          text: 'glh-footer.navs.links.no-responsibility',
          url: '/terms/relief',
        },
        {
          text: 'glh-footer.navs.links.privacypolicy',
          url: '/terms/privacypolicy',
        },
        {
          text: 'glh-footer.navs.links.customerService',
          url: '/terms/customerService',
        },
        {
          text: 'glh-footer.navs.links.weibo',
          url: 'https://weibo.com/p/1006067374427722',
        },
        {
          text: 'glh-footer.navs.links.checkStock',
          url: '/terms/checkStock',
        },
        {
          text: 'glh-footer.navs.links.jdy',
          url: '/terms/jdy-intro',
        },
        {
          text: 'glh-footer.navs.links.dxs',
          url: '/terms/dxs-info',
        },
      ],
    };
  },
  watch: {
    $route() {
      if (this.$route.name === 'index') {
        this.showPartener = true;
      } else {
        this.showPartener = false;
      }
    },
  },
  created() {
    if (this.$route.name === 'index') {
      this.showPartener = true;
    } else {
      this.showPartener = false;
    }
  },
};
